// Constants for general settings keys
export const dropdownKeys = [
  "companyDefaultStatus",
  "extensionCompanyInfo",
  "extensionCompanyWarn",
];

export const toggleKeys = ["removeFlaggedEmails", "removeFlaggedPhones"];

export const jobStatusKey = "jobStatusWhitelist";

// Helper function to check if general settings data exists
export const hasGeneralSettingsData = (generalSettings) =>
  generalSettings.some(
    (setting) =>
      // Check predefined keys
      (setting.kind === "singleChoice" && dropdownKeys.includes(setting.key)) ||
      (setting.kind === "checkbox" && toggleKeys.includes(setting.key)) ||
      setting.key === jobStatusKey ||
      // Also include any setting with isGeneral: true
      setting.isGeneral === true,
  );
